import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'components',
    pluginName: 'PRODUCT',
    entityName: 'GPU',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch gpu action creators

export const fetchGPUInit = () => {
    return crudActions.fetchInit();
};
export const fetchGPUStart = () => {
    return crudActions.fetchStart();
};
export const fetchGPUSuccess = (fetchGPUCount, listGPUCount) => {
    return crudActions.fetchSuccess(fetchGPUCount, listGPUCount);
};
export const fetchGPUFail = () => {
    return crudActions.fetchFail();
};

export const fetchGPUCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchGPUStart());
        try {
            let countRes = await rest.post("components/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchGPUSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchGPUFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch GPU."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchGPUFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch GPU."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchGPU = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchGPUStart());
        try {
            let listRes = await rest.post("components/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchGPUSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchGPUFail());
            return []

        } catch (error) {
            dispatch(fetchGPUFail());
            return []
        }
    }
}


// Load gpu action creators
export const loadGPUInit = () => {
    return crudActions.loadInit();
};
export const loadGPUStart = () => {
    return crudActions.loadStart();
};
export const loadGPUSuccess = loadedGPU => {
    return crudActions.loadSuccess(loadedGPU);
};
export const loadGPUFail = error => {
    return crudActions.loadFail(error);
};
export const loadGPU = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create GPU  action creators
export const createGPUInit = () => {
    return crudActions.createInit();
};
export const createGPUStart = () => {
    return crudActions.createStart();
};
export const createGPUSuccess = createdGPU => {
    return crudActions.createSuccess(createdGPU);
};
export const createGPUFail = error => {
    return crudActions.createFail(error);
};

export const createGPU = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createGPUStart());
        try {
            let res = await rest.post('/components/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createGPUSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created gpu.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createGPUFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create gpu."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create gpu."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createGPUFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit GPU  action creators
export const editGPUInit = () => {
    return crudActions.editInit();
};
export const editGPUStart = () => {
    return crudActions.editStart();
};
export const editGPUSuccess = editedGPU => {
    return crudActions.editSuccess(editedGPU);
};
export const editGPUFail = error => {
    return crudActions.editFail(error);
};
export const editGPU = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editGPUStart());
        try {
            let res = await rest.post('/components/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editGPUSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated gpu.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editGPUFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit gpu."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit gpu."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editGPUFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete gpu action creators
export const bulkDeleteGPUsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteGPUsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteGPUsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteGPUsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteGPUs = gpuIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, gpuIds);
    };
};

// Delete gpu  action creators
export const deleteGPUInit = () => {
    return crudActions.deleteInit();
};
export const deleteGPUStart = () => {
    return crudActions.deleteStart();
};
export const deleteGPUSuccess = deletedGPU => {
    return crudActions.deleteSuccess(deletedGPU);
};
export const deleteGPUFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteGPU = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

export const setGpus = (data) => {
    return ({
        type: 'HANDLE_GPUS',
        gpus: { ...data, fromProduct: true }
    });
}
export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        gpu: data
    });
}
